import { render, staticRenderFns } from "./copyDialog.vue?vue&type=template&id=c4147d6a"
import script from "./copyDialog.vue?vue&type=script&lang=js"
export * from "./copyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports